/**
 * Pentavite live free-gift progress bar (product detail pages).
 * Counts the current cart plus the variant / quantity the shopper is looking at,
 * so switching pack size immediately shows how much more is needed for the gift.
 * The gift is members-only, so the wording follows whoever is looking at the page
 * (member / guest / signed in but not a Rewards member yet).
 */
(function () {
  var el = document.querySelector('[data-pv-gift-progress]');
  if (!el || el.getAttribute('data-pv-ready')) return;
  el.setAttribute('data-pv-ready', '1');

  var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 0;
  var cartTotal = parseInt(el.getAttribute('data-cart-total'), 10) || 0;
  var sectionId = el.getAttribute('data-section-id');
  var format = el.getAttribute('data-money-format') || '';
  var textEl = el.querySelector('[data-pv-gift-progress-text]');
  var barEl = el.querySelector('[data-pv-gift-progress-bar]');
  var loginUrl = el.getAttribute('data-pv-gift-login') || '/account/login';
  var rewardsUrl = '/pages/loyalty';
  var COPY = {
    member: {
      locked: 'Add <b>%AMOUNT%</b> more for your free gift',
      unlocked: '<b>Free gift unlocked</b> — pick your gift in the cart'
    },
    guest: {
      locked: 'Add <b>%AMOUNT%</b> more — <a class="pv-gift-progress__cta pv-gift-progress__cta--ghost" href="' + loginUrl + '">Join free</a> to claim',
      unlocked: '<b>Free gift unlocked!</b> Members only — <a class="pv-gift-progress__cta" href="' + loginUrl + '">Log in / Join free</a>'
    },
    nonmember: {
      locked: 'Add <b>%AMOUNT%</b> more — <a class="pv-gift-progress__cta pv-gift-progress__cta--ghost" href="' + rewardsUrl + '">Join Rewards</a> to claim',
      unlocked: '<b>Free gift unlocked!</b> <a class="pv-gift-progress__cta" href="' + rewardsUrl + '">Join Pentavite Rewards</a> to claim it'
    }
  };
  var copy = COPY[el.getAttribute('data-pv-gift-audience')] || COPY.member;

  var variants = [];
  var variantsEl = document.querySelector('script[data-pv-gift-progress-variants]');
  if (variantsEl) {
    try {
      variants = JSON.parse(variantsEl.textContent) || [];
    } catch (error) {
      variants = [];
    }
  }

  var cartItems = [];

  function money(cents) {
    var units = Math.floor(cents / 100);
    var decimals = Math.abs(cents % 100);
    var decimalsText = (decimals < 10 ? '0' : '') + decimals;
    var thousands = String(units).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var plain = thousands + '.' + decimalsText;
    if (!format) return plain;
    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, thousands.replace(/,/g, '.'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, thousands.replace(/,/g, '.') + ',' + decimalsText)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, thousands)
      .replace(/\{\{\s*amount\s*\}\}/g, plain);
  }

  function productForm() {
    return document.getElementById('product-form-' + sectionId);
  }

  function currentVariant() {
    var form = productForm();
    if (!form) return { id: '', quantity: 1 };
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    return {
      id: idInput ? idInput.value : '',
      quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1
    };
  }

  function inCart(variantId) {
    for (var i = 0; i < cartItems.length; i++) {
      if (String(cartItems[i].id) === String(variantId)) return true;
    }
    return false;
  }

  function variantPrice(variantId) {
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) return variants[i].price;
    }
    return 0;
  }

  function render() {
    if (!textEl || !barEl || threshold <= 0) return;
    var selected = currentVariant();
    var addition = inCart(selected.id) ? 0 : variantPrice(selected.id) * selected.quantity;
    var total = cartTotal + addition;
    var left = threshold - total;
    var percent = Math.min(100, Math.max(0, Math.round((total / threshold) * 100)));

    var needsLogin = (el.getAttribute('data-pv-gift-audience') || 'guest') !== 'member';
    if (left > 0) {
      textEl.innerHTML = copy.locked.replace('%AMOUNT%', money(left));
      el.classList.remove('pv-gift-progress--unlocked');
      el.classList.remove('pv-gift-progress--needs-login');
    } else {
      textEl.innerHTML = copy.unlocked;
      el.classList.add('pv-gift-progress--unlocked');
      if (needsLogin) {
        el.classList.add('pv-gift-progress--needs-login');
      } else {
        el.classList.remove('pv-gift-progress--needs-login');
      }
    }
    barEl.style.width = percent + '%';
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        cartTotal = typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : cart.total_price;
        cartItems = cart.items || [];
        render();
      })
      .catch(function () {});
  }

  function markInteracted(event) {
    var target = event.target;
    if (!target || target.nodeType !== 1) return;
    var name = target.getAttribute && target.getAttribute('name');
    var watchedField = name === 'id' || name === 'quantity' || name === 'plus' || name === 'minus';
    var watchedContainer = target.closest
      ? target.closest('.yg-quantity-selector, .x-quantity-selector, .product-form__quantity, .x-variant-picker, .variant-selects')
      : null;
    if (!watchedField && !watchedContainer) return;
    // The theme updates its Alpine state after the click, so read the value twice.
    window.setTimeout(render, 0);
    window.setTimeout(render, 250);
  }

  document.addEventListener('change', markInteracted);
  document.addEventListener('input', markInteracted);
  document.addEventListener('click', markInteracted);
  document.addEventListener('eurus:cart:items-changed', refreshCart);

  render();
  refreshCart();
})();
